import UserActions from 'common/redux/actions/user';
import Immutable from 'immutable';
import { ExtendedUser } from 'common/models/internal/ExtendedUser';
import { mapFromList, mergeDeepWithRemoval } from 'common/utils/ImmutableUtils';

export const userReducer = (state = Immutable.fromJS({}), action) => {
    switch (action.type) {
        case UserActions.FETCH_USER_REQUEST: {
            const { clientId } = action;
            return state.setIn(
                [clientId, 'users', 'status', 'isRiderListLoading'],
                true
            );
        }

        case UserActions.FETCH_USER_ERROR: {
            const { clientId } = action;
            return state.setIn(
                [clientId, 'users', 'status', 'isRiderListLoading'],
                false
            );
        }

        case UserActions.FETCH_USER_END: {
            const { clientId } = action;
            return state.setIn(
                [clientId, 'users', 'status', 'isRiderListLoading'],
                false
            );
        }

        case UserActions.FETCH_USER_SUCCESS: {
            const { clientId, response } = action;
            const users = response.map(user => ExtendedUser.fromJS(user));
            const oldUsers = state.getIn(
                [clientId, 'users', 'entity'],
                Immutable.List()
            );
            const oldUsersMap = mapFromList(oldUsers, 'userId');
            const newUsersMap = mapFromList(Immutable.fromJS(users), 'userId');
            const mergedUsersMap = mergeDeepWithRemoval(
                oldUsersMap,
                newUsersMap
            );
            const mergedUsers = mergedUsersMap.toList();
            return state.setIn([clientId, 'users', 'entity'], mergedUsers);
        }
        case UserActions.UPDATE_USER: {
            const { response, clientId } = action;
            const newUser = ExtendedUser.fromJS(response);
            const users = state.getIn(
                [clientId, 'users', 'entity'],
                Immutable.List()
            );
            const index = users.findIndex(user => {
                return (
                    user.clientId === newUser.clientId &&
                    user.userId === newUser.userId
                );
            });
            if (index !== -1) {
                return state.setIn(
                    [clientId, 'users', 'entity', index],
                    newUser
                );
            } else {
                return state.setIn(
                    [clientId, 'users', 'entity'],
                    users.push(newUser)
                );
            }
        }
        default:
            return state;
    }
};
